module.exports = __webpack_public_path__ + "static/media/LogoForbes.0b7c2e7d.svg";